import React, { useContext, useEffect, useState } from "react";

import { Icon } from "@iconify/react";
import logo from "../assets/images/Opt_logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import useGetEmail from "../hooks/GetEmail";
import axios from "axios";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import Navbar from "../dashboard/components/navbar/Navbar";
import { tableDataContext } from "../dashboard/context/productData";

function UserSidebar({ children }) {
  const [activeTab, setActiveTab] = useState("home");
  const [show, setshow] = useState(false);
  const [hide, setHide] = useState(true);
  const Location = useLocation();
  const navigate = useNavigate();
  const { email, loading, error } = useGetEmail();
  const { id } = useParams();
  const { setResponseDatapdf } = useContext(tableDataContext);
  const role = secureLocalStorage.getItem("role");
  const location = useLocation();
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    const wsInstance = new WebSocket(
      `wss://aipricingtool-python.onrender.com/ws/${id}`
    );

    wsInstance.onopen = () => {
      console.log("WebSocket connection established.");
    };
    wsInstance.onmessage = (event) => {
      const message = JSON.parse(event.data);
      console.log("message", message);
      setResponseDatapdf(message);
      if (message == "done") {
        toast.success("Brochure upload Sucessful");
      }
    };
  }, []);

  // if (Array.isArray(prevData)) {
  //   console.log("goingif")
  //   return [...prevData, message];
  // } else {
  //   console.log("goingelse")
  //   return [message];
  // }

  const handleLogout = () => {
    localStorage.clear();
    secureLocalStorage.clear();
    axios
      .post("https://aipricingtool-python.onrender.com/Signout", {
        email: email.useremail,
      })
      .then((res) => {
        console.log(res.data);
        toast.success("Sign Out Successful");
        navigate("/signin");
      })
      .catch((err) => {
        console.log("error Signing out", err);
        toast.error("SignOut Failed!!");
      });
  };

  return (
    <>
      <div className="relative">
        <div className="absolute right-0 w-full lg:w-[80%] ">
          <Navbar show={show} setshow={setshow} email={email} hide={hide} />
          <div className="w-full">{children}</div>
        </div>
        <div
          className={`sidebar absolute lg:static  -translate-x-[700px] lg:translate-x-0 transition-transform duration-500 z-10 bg-white  left-0 top-0    lg:w-[20%] pt-6 border-r border-black-300 h-screen  flex flex-col justify-between pb-3 ${
            show ? "sidebarshow" : ""
          }`}
        >
          <div className="sidebar_bottom flex flex-col justify-between">
            <div className="text-5xl  flex justify-between lg:justify-center items-center px-5 pb-10 Rubik font-semibold text-center">
              <div className="w-[142px] h-[33px]">
                <img src={logo} alt="" className="h-full w-full" />
              </div>
              <Icon
                icon="bitcoin-icons:cross-filled"
                className=" cursor-pointer lg:hidden ml-5"
                color="#d76e3e"
                width="35"
                height="35"
                onClick={() => setshow(false)}
              />
            </div>
            <ul className="flex flex-col gap-4 pe-2 ">
              <div
                to={`/userDashboard/${id}`}
                activeClassName="active"
                className={` flex items-center     gap-2 ps-9 py-4 b rounded-e-xl cursor-pointer duration-500 hover:text-white 
                ${
                  Location.pathname === `/userDashboard/${id}`
                    ? "activetab"
                    : "tab"
                }
                `}
                onClick={() => {
                  handleTabChange("userDashboard");
                  navigate(`/userDashboard/${id}`);
                }}
              >
                <Icon
                  icon="material-symbols:home"
                  width="20"
                  height="20"
                  opacity="0.4"
                />
                <label className=" text-xl  opacity-40  font-semibold">
                  Home
                </label>
              </div>
              <div
                to={`/account/${id}`}
                activeClassName="active"
                className={` flex items-center     gap-2 ps-9 py-4 b rounded-e-xl cursor-pointer duration-500 hover:text-white 
                ${Location.pathname === `/account/${id}` ? "activetab" : "tab"}
                `}
                onClick={() => {
                  handleTabChange("account");
                  navigate(`/account/${id}`);
                }}
              >
                <Icon
                  icon="mdi:accounts"
                  width="20"
                  height="20"
                  opacity="0.4"
                />
                <label className=" text-xl  opacity-40  font-semibold">
                  Account
                </label>
              </div>
            </ul>
          </div>

          <div className="w-full px-3  ">
            <button
              className="logout btn_hover w-full font-semibold  py-4 text-center  text-white rounded-xl"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserSidebar;
